module.exports = __webpack_public_path__ + "img/empty-state-background.2c8c26df.svg";